/* Billyhops — Our Story: journey carousel drag-to-scroll */
(function () {
  'use strict';

  function initJourneyCarousel() {
    var track = document.getElementById('bhStoryJourneyTrack');
    if (!track) return;

    var dragging = false;
    var startX = 0;
    var scrollLeft = 0;

    track.addEventListener('mousedown', function (e) {
      dragging = true;
      track.classList.add('dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener('mouseleave', function () {
      dragging = false;
      track.classList.remove('dragging');
    });

    track.addEventListener('mouseup', function () {
      dragging = false;
      track.classList.remove('dragging');
    });

    track.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJourneyCarousel);
  } else {
    initJourneyCarousel();
  }
})();
